import React from 'react';
import { MessageCircleIcon, ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const whatsappLink = 'https://wa.me/12817980349';
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 pt-20 overflow-hidden" data-id="element-44">
      {/* Background Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-radial from-gold/10 via-dark-900 to-dark-900 z-0" data-id="element-45"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-46">
        {/* Logo */}
        <div className="mb-8 relative" data-id="element-47">
          <div className="absolute inset-0 bg-gold blur-2xl opacity-20 rounded-full" data-id="element-48"></div>
          <img src="https://cdn.magicpatterns.com/uploads/tytkshGoctiAv8HZxiVooC/nano-banana-2_Ultra-realistic_extreme_close-up_of_a_luxury_emblem._The_design_from_the_referen-0.jpg" alt="Killshot Digital Venture Emblem" className="relative w-32 h-32 md:w-40 md:h-40 object-cover rounded-full border-2 border-gold shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-49" />
        </div>

        {/* Headlines */}
        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white tracking-tight mb-6 leading-tight" data-id="element-50">
          Infraestructura Digital de <br className="hidden md:block" data-id="element-51" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-gold to-gold-dark" data-id="element-52">
            Alto Rendimiento
          </span>
        </h1>

        <p className="font-sans text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-53">
          Elevamos negocios locales de plantillas genéricas a experiencias
          premium de alto ticket.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-54">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-transparent border border-gold text-gold px-8 py-4 rounded-sm font-sans font-semibold hover:bg-gold/10 transition-colors min-w-[280px]" data-id="element-55">
            <span data-id="element-56">Solicitar mi Auditoría Gratuita</span>
            <ArrowRightIcon className="w-5 h-5" data-id="element-57" />
          </a>

          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-gradient-to-r from-gold to-gold-dark text-black px-8 py-4 rounded-sm font-sans font-semibold hover:opacity-90 transition-opacity hover-gold-glow min-w-[280px]" data-id="element-58">
            <MessageCircleIcon className="w-5 h-5" data-id="element-59" />
            <span data-id="element-60">Hablemos por WhatsApp</span>
          </a>
        </div>

        {/* Decorative Line */}
        <div className="mt-16 w-24 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-61"></div>
      </div>
    </section>;
}